/**
 * @generated SignedSource<<3c37584305d591fba62ac184a8588917>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type assetLibraryQueriesUpdateAIAssetLibraryAssetMutation$variables = {
  categoryID?: number | null;
  id: string;
  name: string;
};
export type assetLibraryQueriesUpdateAIAssetLibraryAssetMutation$data = {
  readonly updateAIAssetLibraryAsset: {
    readonly assetType: string;
    readonly categoryID: number | null;
    readonly categoryName: string | null;
    readonly createdDate: string;
    readonly durationSeconds: number | null;
    readonly fileName: string;
    readonly filePath: string;
    readonly fileServerID: number;
    readonly fileSizeBytes: number | null;
    readonly fileUrl: string;
    readonly height: number | null;
    readonly id: string;
    readonly metadata: {
      readonly aspectRatio: string | null;
      readonly backgroundImageUrl: string | null;
      readonly backgroundPreset: number | null;
      readonly clothingImageUrl: string | null;
      readonly clothingPreset: number | null;
      readonly colorPreset: number | null;
      readonly ctaText: string | null;
      readonly durationSeconds: number | null;
      readonly effectPreset: number | null;
      readonly formatPreset: number | null;
      readonly generateAudio: boolean | null;
      readonly guidanceScale: number | null;
      readonly height: number | null;
      readonly language: string | null;
      readonly layoutPreset: number | null;
      readonly maskImageUrl: string | null;
      readonly materialPreset: number | null;
      readonly model: string | null;
      readonly moodPreset: number | null;
      readonly negativePrompt: string | null;
      readonly personImageUrl: string | null;
      readonly personPreset: number | null;
      readonly posePreset: number | null;
      readonly prompt: string | null;
      readonly resolution: string | null;
      readonly savedAt: string | null;
      readonly scaleFactor: number | null;
      readonly seed: number | null;
      readonly sourceImageUrls: ReadonlyArray<string> | null;
      readonly steps: number | null;
      readonly strength: number | null;
      readonly styleImageUrl: string | null;
      readonly stylePreset: number | null;
      readonly subtitle: string | null;
      readonly surfacePreset: number | null;
      readonly title: string | null;
      readonly toolId: string | null;
      readonly toolName: string | null;
      readonly videoPreset: number | null;
      readonly width: number | null;
    } | null;
    readonly modifiedDate: string;
    readonly name: string;
    readonly sourceToolID: string | null;
    readonly thumbnailUrl: string | null;
    readonly width: number | null;
  };
};
export type assetLibraryQueriesUpdateAIAssetLibraryAssetMutation = {
  response: assetLibraryQueriesUpdateAIAssetLibraryAssetMutation$data;
  variables: assetLibraryQueriesUpdateAIAssetLibraryAssetMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "categoryID"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "id"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "name"
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "width",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "height",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "durationSeconds",
  "storageKey": null
},
v6 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "categoryID",
        "variableName": "categoryID"
      },
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      },
      {
        "kind": "Variable",
        "name": "name",
        "variableName": "name"
      }
    ],
    "concreteType": "AIAssetLibraryAssetDTO",
    "kind": "LinkedField",
    "name": "updateAIAssetLibraryAsset",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "categoryID",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "assetType",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "sourceToolID",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "fileServerID",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "filePath",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "fileName",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "fileUrl",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "fileSizeBytes",
        "storageKey": null
      },
      (v3/*:: as any*/),
      (v4/*:: as any*/),
      (v5/*:: as any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "thumbnailUrl",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "AssetGenerationSettings",
        "kind": "LinkedField",
        "name": "metadata",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "toolId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "toolName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "prompt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "negativePrompt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "model",
            "storageKey": null
          },
          (v3/*:: as any*/),
          (v4/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "seed",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "strength",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "steps",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "guidanceScale",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "sourceImageUrls",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "styleImageUrl",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "maskImageUrl",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "backgroundPreset",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "backgroundImageUrl",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "personPreset",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "personImageUrl",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "clothingPreset",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "clothingImageUrl",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "posePreset",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "effectPreset",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "surfacePreset",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "moodPreset",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "materialPreset",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "colorPreset",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "layoutPreset",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "formatPreset",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "stylePreset",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "videoPreset",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "scaleFactor",
            "storageKey": null
          },
          (v5/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "resolution",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "aspectRatio",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "generateAudio",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "language",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "title",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "subtitle",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "ctaText",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "savedAt",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "createdDate",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "modifiedDate",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "categoryName",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*:: as any*/),
      (v1/*:: as any*/),
      (v2/*:: as any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "assetLibraryQueriesUpdateAIAssetLibraryAssetMutation",
    "selections": (v6/*:: as any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*:: as any*/),
      (v2/*:: as any*/),
      (v0/*:: as any*/)
    ],
    "kind": "Operation",
    "name": "assetLibraryQueriesUpdateAIAssetLibraryAssetMutation",
    "selections": (v6/*:: as any*/)
  },
  "params": {
    "cacheID": "8068a5ff54b58e425f06476bec525b19",
    "id": null,
    "metadata": {},
    "name": "assetLibraryQueriesUpdateAIAssetLibraryAssetMutation",
    "operationKind": "mutation",
    "text": "mutation assetLibraryQueriesUpdateAIAssetLibraryAssetMutation(\n  $id: ID!\n  $name: String!\n  $categoryID: Int\n) {\n  updateAIAssetLibraryAsset(id: $id, name: $name, categoryID: $categoryID) {\n    id\n    categoryID\n    name\n    assetType\n    sourceToolID\n    fileServerID\n    filePath\n    fileName\n    fileUrl\n    fileSizeBytes\n    width\n    height\n    durationSeconds\n    thumbnailUrl\n    metadata {\n      toolId\n      toolName\n      prompt\n      negativePrompt\n      model\n      width\n      height\n      seed\n      strength\n      steps\n      guidanceScale\n      sourceImageUrls\n      styleImageUrl\n      maskImageUrl\n      backgroundPreset\n      backgroundImageUrl\n      personPreset\n      personImageUrl\n      clothingPreset\n      clothingImageUrl\n      posePreset\n      effectPreset\n      surfacePreset\n      moodPreset\n      materialPreset\n      colorPreset\n      layoutPreset\n      formatPreset\n      stylePreset\n      videoPreset\n      scaleFactor\n      durationSeconds\n      resolution\n      aspectRatio\n      generateAudio\n      language\n      title\n      subtitle\n      ctaText\n      savedAt\n    }\n    createdDate\n    modifiedDate\n    categoryName\n  }\n}\n"
  }
};
})();

(node as any).hash = "797678e06ddf4943428b7f4a24230c5b";

export default node;
